import hasRole from './permission/hasRole'
import hasPermi from './permission/hasPermi'
import copyText from './common/copyText'
// trim
import trim from './common/trim'
// confirm
import confirm from './common/confirm'

export default function directive(app){
  app.directive('hasRole', hasRole)
  app.directive('hasPermi', hasPermi)
  app.directive('copyText', copyText)
  app.directive('trim', trim)
  app.directive('confirm', confirm)
}